export default {
  CROP: 'crop',
  THUMBNAIL: 'thumbnail',
  PLACEHOLDERS: 'placeholders',
};



// WEBPACK FOOTER //
// ./src/infrastructure/DragTypes.ts